import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb } from "antd";
import { IconEuroSignSolid, IconGearSolid } from "../../../../icon";
import { useNavigate } from "react-router-dom";
import Pricing from "../../fragments/pricing";

function PriceSettings() {
  const navigate = useNavigate();
  return <div  style={{ height: "100%", overflow: "scroll", display: 'flex', flexDirection: 'column' }}>
      <Breadcrumb
        style={{ marginBottom: "24px" }}
        items={[
          {
            onClick: () => navigate('/'),
            title: <HomeOutlined />,
          },
          {
            title: (
              <>
                <IconGearSolid />
                <span>Einstellungen</span>
              </>
            ),
          },  
          {
            title: (
              <>
                <IconEuroSignSolid /> Preisgestaltung
              </>
            )
          },            
        ]}
      />
    <Pricing customerId={null} />
  </div>
}

export default PriceSettings;